import Vue from "vue";
import {
  SET_DOMEX_STEP,
  SET_DOMEX_PHASE,
  SET_DOMEX_SUBMISSION_REF,
  SET_DOMEX_SAME_AS_SUBSCRIBER,
  SET_DOMEX_ACTIVE_BENEFICIARY,
  SET_DOMEX_CONTRACT_FIELD,
  SET_DOMEX_PERSON_FIELD,
  SET_DOMEX_BENEFICIARY_FIELD,
  SET_DOMEX_CONSENT,
  ADD_DOMEX_BENEFICIARY,
  REMOVE_DOMEX_BENEFICIARY,
  COPY_SUBSCRIBER_TO_INSURED,
  SET_DOMEX_FILE,
  SET_DOMEX_ERRORS,
  SET_DOMEX_ERROR,
  CLEAR_DOMEX_ERRORS,
  SET_DOMEX_LOADING,
  RESET_DOMEX,
} from "./mutation-types";

import { buildEmptyPerson, buildEmptyBeneficiary } from "./state";

export default {
  [SET_DOMEX_STEP](state, step) {
    state.currentStep = step;
  },

  [SET_DOMEX_PHASE](state, phase) {
    state.appPhase = phase;
  },

  [SET_DOMEX_SUBMISSION_REF](state, ref) {
    state.submissionRef = ref;
  },

  [SET_DOMEX_SAME_AS_SUBSCRIBER](state, value) {
    state.sameAsSubscriber = value;
  },

  [SET_DOMEX_ACTIVE_BENEFICIARY](state, index) {
    state.activeBeneficiaryIndex = index;
  },

  // ── Mise à jour réactive d'un champ contrat
  [SET_DOMEX_CONTRACT_FIELD](state, { key, value }) {
    Vue.set(state.form.contract, key, value);
  },

  // ── Mise à jour réactive d'un champ souscripteur OU assuré
  [SET_DOMEX_PERSON_FIELD](state, { target, key, value }) {
    // target = "subscriber" | "insured"
    Vue.set(state.form[target], key, value);
  },

  // ── Mise à jour réactive d'un champ bénéficiaire
  [SET_DOMEX_BENEFICIARY_FIELD](state, { index, key, value }) {
    Vue.set(state.form.beneficiaries[index], key, value);
  },

  [SET_DOMEX_CONSENT](state, { key, value }) {
    Vue.set(state.form, key, value);
  },

  [ADD_DOMEX_BENEFICIARY](state) {
    if (state.form.beneficiaries.length >= 3) return;
    state.form.beneficiaries.push(buildEmptyBeneficiary());
    state.errors.beneficiaries.push({});
    state.activeBeneficiaryIndex = state.form.beneficiaries.length - 1;
  },

  [REMOVE_DOMEX_BENEFICIARY](state, index) {
    if (state.form.beneficiaries.length <= 1) return;
    state.form.beneficiaries.splice(index, 1);
    state.errors.beneficiaries.splice(index, 1);
    state.activeBeneficiaryIndex = Math.max(
      0,
      state.activeBeneficiaryIndex - 1
    );
  },

  [COPY_SUBSCRIBER_TO_INSURED](state) {
    // Copie profonde des champs du souscripteur vers l'assuré
    Object.keys(state.form.subscriber).forEach((k) => {
      Vue.set(state.form.insured, k, state.form.subscriber[k]);
    });
  },

  [SET_DOMEX_FILE](state, { key, file }) {
    // key = "subscriberCni" | "insuredCni"
    Vue.set(state.files, key, file);
  },

  [SET_DOMEX_ERRORS](state, { section, errors }) {
    // section = "contract" | "subscriber" | "insured" | "beneficiaries"
    Vue.set(state.errors, section, errors);
  },

  [SET_DOMEX_ERROR](state, { key, message }) {
    Vue.set(state.errors, key, message);
  },

  [CLEAR_DOMEX_ERRORS](state) {
    state.errors = {
      contract: {},
      subscriber: {},
      insured: {},
      beneficiaries: state.form.beneficiaries.map(() => ({})),
      consent: "",
      submit: "",
    };
  },

  [SET_DOMEX_LOADING](state, { key, value }) {
    Vue.set(state.loading, key, value);
  },

  [RESET_DOMEX](state) {
    state.currentStep = 0;
    state.appPhase = "form";
    state.submissionRef = "";
    state.sameAsSubscriber = false;
    state.activeBeneficiaryIndex = 0;
    state.form = {
      contract: {
        projectType: "",
        apporteurType: "Aurée Services", // ← NOUVEAU : 'Aurée Services' | 'Autre'
        apporteurCustom: "", // ← NOUVEAU : valeur libre si Autre
        cotisation: null,
        duration: "",
        effectDate: "",
      },
      subscriber: buildEmptyPerson(),
      insured: buildEmptyPerson(),
      beneficiaries: [buildEmptyBeneficiary()],
      consentExact: false,
      consentData: false,
      consentTerms: false,
    };
    state.files = { subscriberCni: null, insuredCni: null };
    state.errors = {
      contract: {},
      subscriber: {},
      insured: {},
      beneficiaries: [{}],
      consent: "",
      submit: "",
    };
    state.loading = { submit: false };
  },
};
